import PropTypes from 'prop-types';
import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Avatar, Box, Drawer, Link, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
// mock
// import account from '../../../_mock/account';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Logo from '../../../components/logo';
import NavSection from '../../../components/nav-section';
import Scrollbar from '../../../components/scrollbar';
//

import { AuthContext } from 'src/components/Context/Auth/auth.context';
import SvgColor from '../../../components/svg-color';

//////////////////////////////////////////////////////////

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;
const iconsWithExtention = (name) => <SvgColor src={`/assets/icons/navbar/${name}`} sx={{ width: 1, height: 1 }} />;

const guestNav = [
  {
    title: 'dashboard',
    path: '/app/dashboard',
    icon: icon('ic_analytics'),
  },

  {
    title: 'Foot Falls',
    path: '/app/Footfalls',
    icon: icon('employer'),
  },
  // {
  //   title: 'Logout',
  //   path: '/login',
  //   icon: icon('ic_lock'),
  // },
];
const printingNav = [
  {
    title: 'dashboard',
    path: '/app/dashboard',
    icon: icon('ic_analytics'),
  },

  {
    title: 'Foot Falls',
    path: '/app/Footfalls',
    icon: icon('employer'),
  },
  // {
  //   title: 'Logout',
  //   path: '/login',
  //   icon: icon('ic_lock'),
  // },
];
const masterNav = [
  {
    title: 'dashboard',
    path: '/app/dashboard',
    icon: icon('ic_analytics'),
  },
  {
    title: 'user',
    path: '/app/user',
    icon: icon('ic_user'),
  },
  {
    title: 'Foot Falls',
    path: '/app/Footfalls',
    icon: icon('employer'),
    // subMenuItems: [
    //   {
    //     title: 'Jobssssssssss',
    //     path: '/app/Vacancies',
    //     icon: icon('employer'),
    //   },
    // ],
  },

  {
    title: 'All Enquiries',
    path: '/app/EnquiryList',
    icon: icon('employer'),
  },
  // {
  //   title: 'Candidates',
  //   path: '/app/Candidates',
  //   icon: icon('employer'),
  // },

  {
    title: 'Employers',
    path: '/app/Companies',
    icon: icon('employer'),
  },
  {
    title: 'Clients',
    path: '/app/Clients',
    icon: icon('clients'),
  },
  {
    title: 'Employers Company wise',
    path: '/app/CompaniesByUserCompany',
    icon: icon('employer'),
  },
  {
    title: 'Clients Company Wise',
    path: '/app/ClientsByCompany',
    icon: icon('clients'),
  },
  // {
  //   title: 'Clients',
  //   path: '/app/SAPClients',
  //   icon: icon('clients'),
  // },
  // {
  //   title: 'Employers',
  //   path: '/app/SAPEmployers',
  //   icon: icon('employer'),
  // },
  {
    title: 'Unassigned Employers',
    path: '/app/CompanyAssignment',
    icon: icon('employer'),
  },
  {
    title: 'Unassigned Clients',
    path: '/app/ClientsAssignment',
    icon: icon('clients'),
  },
  {
    title: 'Unassigned Tasks',
    path: '/app/TasksAssignment',
    icon: icon('TasksList'),
  },
  {
    title: 'My Tasks',
    path: '/app/MyTasks',
    icon: icon('TasksList'),
  },
  {
    title: 'Assigned Tasks',
    path: '/app/AssignedTasks',
    icon: icon('TasksList'),
  },
  {
    title: 'Forwarded Tasks',
    path: '/app/ForwardedTasks',
    icon: icon('TasksList'),
  },
  {
    title: 'My Opportunities',
    path: '/app/MyOpportunities',
    icon: icon('listIcon'),
  },
  {
    title: 'Recruitment',
    path: '/app/Recruitment',
    icon: icon('recruitment'),
  },
  // {
  //   title: 'Reports',
  //   path: '/app/Reports',
  //   icon: icon('Reports'),
  // },

  // {
  //   title: 'blog',
  //   path: '/app/blog',
  //   icon: icon('ic_blog'),
  // },
  // {
  //   title: 'Logout',
  //   path: '/login',
  //   icon: icon('ic_lock'),
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: icon('ic_disabled'),
  // },
];
//////////////////////////////////////////////////////
// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();
  let {
    authState: { isAuthenticated, name, userRole, firstPasswordChanged, profilePicture, deptId },
  } = useContext(AuthContext);

  const navManager = [
    {
      title: 'dashboard',
      path: '/app/dashboard',
      icon: icon('ic_analytics'),
    },

    {
      title: 'Foot Falls',
      path: '/app/Footfalls',
      icon: icon('employer'),
    },
    {
      // title: deptId == '6' ? 'Enquiries' : deptId == '7' ? 'Enquiries' : deptId == '1' ? 'Enquiries' : 'Enquires',
      title: 'Enquiries',
      path: '/app/EnquiryList',
      icon: icon('employer'),
    },
    {
      title: 'Employers',
      path: '/app/Companies',
      icon: icon('employer'),
    },
    {
      title: 'Clients',
      path: '/app/Clients',
      icon: icon('clients'),
    },
    // {
    //   title: 'Clients',
    //   path: '/app/SAPClients',
    //   icon: icon('clients'),
    // },
    // {
    //   title: 'Employers',
    //   path: '/app/SAPEmployers',
    //   icon: icon('employer'),
    // },
    {
      title: 'Unassigned Employers',
      path: '/app/CompanyAssignment',
      icon: icon('employer'),
    },
    {
      title: 'Unassigned Clients',
      path: '/app/ClientsAssignment',
      icon: icon('clients'),
    },
    {
      title: 'Unassigned Tasks',
      path: '/app/TasksAssignment',
      icon: icon('TasksList'),
    },
    {
      title: 'My Tasks',
      path: '/app/MyTasks',
      icon: icon('TasksList'),
    },
    {
      title: 'Assigned Tasks',
      path: '/app/AssignedTasks',
      icon: icon('TasksList'),
    },
    {
      title: 'Forwarded Tasks',
      path: '/app/ForwardedTasks',
      icon: icon('TasksList'),
    },
    {
      title: 'My Opportunities',
      path: '/app/MyOpportunities',
      icon: icon('listIcon'),
    },
    // {
    //   title: 'Reports',
    //   path: '/app/Reports',
    //   icon: icon('Reports'),
    // },

    // {
    //   title: 'blog',
    //   path: '/app/blog',
    //   icon: icon('ic_blog'),
    // },
    // {
    //   title: 'Logout',
    //   path: '/login',
    //   icon: icon('ic_lock'),
    // },
    // {
    //   title: 'Not found',
    //   path: '/404',
    //   icon: icon('ic_disabled'),
    // },
  ];

  const navAgent = [
    {
      title: 'dashboard',
      path: '/app/dashboard',
      icon: icon('ic_analytics'),
    },

    {
      title: 'Foot Falls',
      path: '/app/Footfalls',
      icon: icon('employer'),
    },
    {
      // title: deptId == '6' ? 'Enquiries' : deptId == '7' ? 'Enquiries' : deptId == '1' ? 'Enquiries' : 'Enquires',
      title: 'Enquiries',
      path: '/app/EnquiryList',
      icon: icon('employer'),
    },
    {
      title: 'Employers',
      path: '/app/Companies',
      icon: icon('employer'),
    },
    {
      title: 'Clients',
      path: '/app/Clients',
      icon: icon('clients'),
    },
    {
      title: 'My Tasks',
      path: '/app/MyTasks',
      icon: icon('TasksList'),
    },
    {
      title: 'Assigned Tasks',
      path: '/app/AssignedTasks',
      icon: icon('TasksList'),
    },
    {
      title: 'Forwarded Tasks',
      path: '/app/ForwardedTasks',
      icon: icon('TasksList'),
    },
    {
      title: 'My Opportunities',
      path: '/app/MyOpportunities',
      icon: icon('listIcon'),
    },
  ];

  if (deptId == '6') {
    navManager.push({
      title: 'Recruitment',
      path: '/app/Recruitment',
      icon: icon('recruitment'),
    });
    navAgent.push({
      title: 'Recruitment',
      path: '/app/Recruitment',
      icon: icon('recruitment'),
    });
  }
  const isDesktop = useResponsive('up', 'lg');
  //console.log('Name::::', name + userRole + isAuthenticated + firstPasswordChanged);
  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname, name]);

  // console.log('profilePictureprofilePicture', profilePicture);
  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
        <Logo />
      </Box>

      <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none">
          <StyledAccount>
            <Avatar
              src={profilePicture != 'null' ? `/pictures/${profilePicture}` : account.photoURL}
              // alt={account.photoURL}
            />

            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {/* {account.displayName} */}
                {name}
              </Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {userRole}
              </Typography>
            </Box>
          </StyledAccount>
        </Link>
      </Box>

      <NavSection
        data={
          userRole === 'Master'
            ? masterNav
            : userRole === 'Manager'
            ? navManager
            : userRole === 'Agent'
            ? navAgent
            : userRole === 'Printing Agent'
            ? navAgent
            : userRole === 'Guest'
            ? guestNav
            : guestNav
        }
      />

      <Box sx={{ flexGrow: 1 }} />

      {/* <Box sx={{ px: 2.5, pb: 3, mt: 10 }}>
        <Stack alignItems="center" spacing={3} sx={{ pt: 5, borderRadius: 2, position: 'relative' }}>
          <Box
            component="img"
            src="/assets/illustrations/illustration_avatar.png"
            sx={{ width: 100, position: 'absolute', top: -50 }}
          />

          <Box sx={{ textAlign: 'center' }}>
            <Typography gutterBottom variant="h6">
              Get more?
            </Typography>

            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              From only $69
            </Typography>
          </Box>

          <Button href="https://material-ui.com/store/items/minimal-dashboard/" target="_blank" variant="contained">
            Upgrade to Pro
          </Button>
        </Stack>
      </Box> */}
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
